// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AffordableCarsGraphic_overlay__OmF31","slotMachine":"AffordableCarsGraphic_slotMachine__pxsPN","fadeIn":"AffordableCarsGraphic_fadeIn__rMUak"};